export default __webpack_public_path__ + "97d25893816419bb41e03150f22ee87a.jpg";